import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = ({ closeMenu }) => {
    const handleClick = () => {
        if (closeMenu) {
            closeMenu();
        }
    };

    return (
        <>
            <HashLink className="px-4 hover:text-orange-900" smooth to="/#about" onClick={handleClick}>
                About
            </HashLink>
            <HashLink className="px-4 hover:text-orange-900" smooth to="/#services" onClick={handleClick}>
                Services
            </HashLink>
            <HashLink className="px-4 hover:text-orange-900" smooth to="/#portfolio" onClick={handleClick}>
                Portfolio
            </HashLink>
            <HashLink className="px-4 hover:text-orange-900" to="/internship" onClick={handleClick}>
                Internship Program
            </HashLink>
            <HashLink className="px-4 hover:text-orange-900" to="/contact#contact" onClick={handleClick}>
                Contact Us
            </HashLink>
        </>
    )
}

export default NavLinks;
